import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ProductDetail } from '@usf/product-types';
import { PimNutrientsProduction } from '@usf/product-types/Product-Detail';
import { Nutrient, RowDisplayEnum } from '../../models/nutrient.model';
import * as nutritionalInfoUtil from '../../utils/nutritional-info.util';

@Component({
  selector: 'app-product-detail-nutritional-info',
  templateUrl: './product-detail-nutritional-info.component.html',
  styleUrls: ['./product-detail-nutritional-info.component.scss'],
})
export class ProductDetailNutritionalInfoComponent implements OnChanges {
  @Input() productDetail: ProductDetail;
  @Input() isUsdaNutritionFlagOn: boolean;

  supplementalFacts: PimNutrientsProduction[];
  calories: number;
  servingSizeData: string;
  rowType = RowDisplayEnum;
  nutrientsData: Nutrient[];
  nutrientIsNotAvailable: boolean;

  caloriesFromFat: number;
  isUsda: boolean;

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes.productDetail?.currentValue ||
      changes.isUsdaNutritionFlagOn?.currentValue
    ) {
      let nutrients = this.productDetail?.listPIMNutrientsProduction;
      nutrients = nutritionalInfoUtil.filterUsdaNutrients(
        nutrients,
        this.isUsdaNutritionFlagOn,
      );
      nutrients = nutritionalInfoUtil.filterNutrientsByPriority(nutrients);

      this.isUsda = nutritionalInfoUtil.isNutrientUsda(
        nutrients?.[0],
        this.isUsdaNutritionFlagOn,
      );
      this.supplementalFacts = nutritionalInfoUtil.extractSupplementalFacts(
        nutrients,
        this.isUsda,
      );
      this.calories = nutritionalInfoUtil.extractCalories(nutrients);
      this.caloriesFromFat =
        nutritionalInfoUtil.extractCaloriesFromFat(nutrients);
      this.servingSizeData = nutritionalInfoUtil.extractServingSize(nutrients);
      this.nutrientsData = nutritionalInfoUtil.extractNutrients(
        nutrients,
        this.isUsda,
      );
      this.nutrientIsNotAvailable =
        !nutritionalInfoUtil.isNutrientDataAvailable(nutrients, this.isUsda);
    }
  }
}
